import { gql } from "apollo-boost"

export const DELETE_IMPLEMENTER_ACCOUNT = gql`
  mutation DeleteImplementerAccount ($id: ID!) {
    DeleteImplementerAccount(id: $id)
  }
`
